/*
 * @Descripttion: 个税预扣税款明细
 * @Date: 2024-12-02 17:12:49
 */
import { route } from './src/router';

const name = 'tax-withholding';

export { name, route };
